import { useParams } from "react-router-dom"
import FormComp from "../../Componentes/FormComp"
import Overlay from "../../Componentes/Overlay"
import Modal from "../../Componentes/Utils/Modal"
import { useModal } from "../../contexts/ModalContext"
import { useEffect, useState } from "react"
import Formulario from "../../Componentes/Utils/Formulario"
import SmallLoading from "../../Componentes/Utils/SmallLoading"
import { useToast } from "../../contexts/ToastContext"
import useApi from "../../hooks/useApi"

const ModalEditLocacao = ({ info, fetchData }) => {

    const { matricula } = useParams();
    const { closeModal } = useModal();
    const { notifySuccess, notifyError } = useToast();

    const api = useApi();

    const [loading, setLoading] = useState(true);

    const [republicas, setRepublicas] = useState([]);
    const [quartos, setQuartos] = useState([]);

    const [formValues, setFormValues] = useState({
        alojamento: info.rep_temp_id || '',
        quarto: info.quarto_rep_temp_id || ''
    })

    useEffect(() => {

        const fetchReps = async () => {
            try {
                setLoading(true);
                const { data } = await api.post("/Painel/API/Colaborador/GetRepublicas/", {
                    republica: info.rep_temp_id,
                    centro_custo: info.locado
                });
                setRepublicas(data.map(obj => ({
                    label: obj.nome,
                    value: obj.identifier
                })));

                if (info.rep_temp_id) {
                    fetchQuartos(info.rep_temp_id);
                }

            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false);
            }
        }

        fetchReps();

    }, [])

    const fetchQuartos = async (repId) => {
        try {
            setLoading(true);
            const { data } = await api.post("/Painel/API/Colaborador/GetQuartos/", {
                republica: repId
            })

            setQuartos(data.map(obj => ({
                label: obj.quarto_name,
                value: obj.identifier
            })))
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (field, value) => {
        setFormValues(prev => ({
            ...prev,
            [field]: value
        }));


        if (field === 'alojamento') {
            setFormValues(prev => ({ ...prev, quarto: '' }));
            setQuartos([]);
            fetchQuartos(value)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const payload = { ...formValues }
            payload.matricula = matricula

            await api.post('/Painel/API/Colaborador/SaveLocacao/', payload)

            await fetchData();
            notifySuccess("Dados atualizados com sucesso!");
            closeModal();
        } catch (e) {
            console.log(e);
            notifyError("Erro ao atualizar dados do colaborador.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal header={true} close={closeModal} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="ALOJAMENTO"
                            type="select"
                            options={republicas}
                            obj={true}
                            valor={formValues.alojamento}
                            changeFunc={(e) => handleChange('alojamento', e.target.value)}
                        />
                        <FormComp
                            title="QUARTO"
                            type="select"
                            options={quartos}
                            obj={true}
                            valor={formValues.quarto}
                            changeFunc={(e) => handleChange('quarto', e.target.value)}
                            disabled={!formValues.alojamento}
                        />
                        <FormComp
                            type="submit"
                            valor={loading ? "SALVANDO..." : "SALVAR"}
                        />
                    </Formulario>
                </Modal>
            </Overlay>
            {loading && (
                <Overlay state={true} >
                    <Modal size="sm" >
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </>
    )
}

export default ModalEditLocacao;